export default "__VITE_ASSET__079cbb38__"